import { createFileRoute, redirect } from '@tanstack/react-router';

import { getEnvVar } from '@/env';
import {
  ChannelSimulator,
  simulatorStatusQueryOptions,
} from '@/features/channel-simulator';
import { queryClient } from '@/query/client';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/channel-simulator/')({
  beforeLoad: async () => {
    const status = getEnvVar('IS_RUNNING_IN_LOCALHOST')
      ? await queryClient
          .ensureQueryData(simulatorStatusQueryOptions())
          .catch(() => null)
      : null;
    if (!status?.active) {
      throw redirect({ to: Routes.Chats as string, replace: true });
    }
  },
  component: ChannelSimulator,
});
